module.exports = __webpack_public_path__ + "img/2.2de310e2.png";